import { useQuery } from "react-query";
import { BannerResponse } from "../../constants/types";
import axios from "../axios";

const handleRequest = async () => {
    const { data } = await axios.get<BannerResponse>(`/api/banners`);
    return data.data;
};

export default function useBanner() {
    return useQuery<BannerResponse["data"]>(["banners"], () =>
        handleRequest(),
    );
}
